import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";

import { getBuyerProductName, getFullName, numberConversion } from "../../../../utils";
import Tooltip from "../../../../helpers/Tooltip";

import { getPMCompanyConfig } from "../../../../setup/pmCompanyConfig";
import { DATE_FORMAT } from "../../../../constants";


const OrderItemTemplate = (props) => {
    const { invoice, materialProductsData, handleTrackingDetailsView } = props

    const userDetails = useSelector((state) => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    let buyerName = getFullName(invoice["user"]?.firstName, invoice["user"]?.lastName)

    const getProductBody = (row) => {
        const buyerDocNo = row?.docNo
        let productNamesListWithDuplicates = []
        let productNamesList = []

        if(row?.buyerInvoiceItems?.length > 0){
            row?.buyerInvoiceItems?.map(eachInvoiceItem => {
                let relatedMaterialItemData = materialProductsData?.find(eachMaterial => eachMaterial.buyerReqItemId === eachInvoiceItem.buyerReqItemId)
                if(relatedMaterialItemData){
                    let productName = getBuyerProductName(relatedMaterialItemData?.companyProdName, relatedMaterialItemData.productName)
                    if(productNamesList.includes(productName)){
                        productNamesListWithDuplicates.push(productName)
                    }else{
                        productNamesList.push(productName)
                    }
                }
            })
        }

        if(productNamesList.length > 0 && productNamesListWithDuplicates.length > 0){
            const totalProductNamesStr = `${productNamesList.join(", ")}, ${productNamesListWithDuplicates.join(", ")}`
            const displayProductNameStr = `${productNamesList.slice(0,6).join(", ")} & ${productNamesList.slice(6).length+productNamesListWithDuplicates.length} more items`

            return (
                <>
                    <Tooltip target={`.custom-tool-tip-${buyerDocNo}`} position="top" autoHide className='post-req-tooltip' >
                        <p className='m-0'>{totalProductNamesStr}</p>
                    </Tooltip>
                    <p className={`custom-tool-tip-${buyerDocNo}`} style={{ margin: "0px"}} >
                    {displayProductNameStr}
                    </p>
                </>
            )
        }
        return (productNamesList.length > 6 ? `${productNamesList.slice(0, 6).join(", ")} & ${productNamesList.slice(6).length} more items` : productNamesList.join(", "))
    }

    return (
        <div className="flex flex-column purchase-order-template" style={{ width: "100%", marginBottom: "14px" }}>
            <div className="flex flex-column md:flex-row flex-1 purchase-order-template-header gap-2">
                <div className="flex flex-row md:flex-column flex-1" style={{ flex: "1.3"}}>
                    <span style={{ fontSize: "13px"}}>INVOICE DATE</span>
                    <span className='md:mt-1 font-bold ml-2 md:ml-0'>{moment(invoice.createdAt).format(DATE_FORMAT)}</span>
                </div>
                <div className="flex flex-row md:flex-column" style={{ flex: "1.3"}}>
                    <span style={{ fontSize: "13px" }}>USER NAME</span>
                    <span className='md:mt-1 font-bold ml-2 md:ml-0'>{buyerName}</span>
                </div>
                <div className="flex flex-row md:flex-column flex-1">
                    <span style={{ fontSize: "13px" }}>TOTAL</span>
                    <span className='md:mt-1 font-bold ml-2 md:ml-0'>&#8377; {numberConversion(parseFloat(invoice.totalInvAmount), numberLocale)}</span>
                </div>
                <div className="flex flex-row md:flex-column " style={{ flex: "3"}}>
                    <span className="product" style={{ fontSize: "13px" }}>PRODUCTS</span>
                    <span className='md:mt-1 ml-2 md:ml-0 product-names' style={{color: "", fontSize: "12px"}}>{getProductBody(invoice)}</span>
                </div>
                <div className="flex flex-column md:align-items-end " style={{ flex: "2" }}>
                    <span 
                        className='font-bold doc-no' 
                        style={{ color: "rgb(18 124 103)", cursor: "pointer" }}
                        onClick={() => window.open(`/buyerInvoice/${invoice["buyerInvoiceId"]}`, '_blank')}
                    >
                        {invoice.docNo} <i className="pi pi-external-link external-link" style={{ color: 'grey', fontWeight: "bold", marginTop: "1px" }}></i> 
                    </span>
                    <a className='md:mt-1' style={{ cursor: "pointer" }} onClick={() => handleTrackingDetailsView(invoice)} >
                        {invoice.invoiceDispatchMap?.[0]?.dispatchNote?.trackingNumber ?
                            <> View Tracking Details <i className="pi pi-window-maximize" style={{ color: 'grey', fontWeight: "bold", marginTop: "1px" }} ></i> </> 
                            :
                            ""
                        }
                    </a>
                </div>
            </div>
            <div className="flex purchase-order-template-footer">
            </div>
        </div>
    )
}

export default OrderItemTemplate;